import React, { useContext } from 'react';
import { Button, Popover, Typography, Paper, Divider } from '@material-ui/core'
import styled from 'styled-components';
import { Formik, Form, FieldArray } from 'formik';
import LoadProceduresItem from './LoadProceduresItem';
import ProjectContext from './ProjectsContext';

const PaperContainer = styled.div`    

`;

const AddToProjectContainer = styled.div`

    display:flex;
    align-items:center;
    justify-content:flex-end;
    background-color:#fafafa;
    height:70px;
    padding-right:5px;
`;

const HeaderContainer = styled.div`
padding:10px;
padding-left:20px;

`;

const HeaderTitle = styled.div`
text-align: left;
font-size: 15px;
font-weight:500;
font-family: "Roboto";
padding-bottom:5px;   
`;

const HeaderSubtitle = styled.div`

text-align: left;
font-size: 13px;
font-family: "Roboto";
`;

const NoProceduresContainer = styled.div`
display:flex;
width:540px;
height:200px;
align-items:center;
justify-content:center;
`

const NoProceduresText = styled.div`
text-align: left;
font-size: 14px;
font-family: "Roboto";
`

const ConfirmationContainer = styled.div`
display:flex;
max-width:600px;
min-height:200px;
align-items:center;
justify-content:center;
padding:20px;
`

const ConfirmationContainerText = styled.div`
text-align: center;
font-size: 14px;
font-weight:300;
font-family: "Roboto";

`


const shouldDisplayConfirmation = (oldCategories, newCategories) => {

  for (let i = 0; i < oldCategories.length; i++) {
    if (oldCategories[i].import === true && newCategories[i].import === false && oldCategories[i].functionProcedureCount) {
      return true;
    }
  }

  return false;

}

const LoadProcedures = props => {

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [displayConfirmation, setdDiplayConfirmation] = React.useState(false);


  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const context = useContext(ProjectContext);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  let { procedureCategories = [] } = context.reduxStore.selectedFunctionDetails;
  procedureCategories = procedureCategories.filter(category => !category.isProject);

  if (!(context.aboutCurrentUser.isAdmin || context.aboutCurrentUser.isGbuAdmin)) {
    return null;
  }


  return (
    <div>
      <Button aria-describedby={id} variant="contained" color="primary" onClick={handleClick}>
        Load Procedures
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <PaperContainer>
          {!displayConfirmation &&
            <>
              <HeaderContainer>
                <HeaderTitle>Select Procedure Categories</HeaderTitle>
                <HeaderSubtitle>
                  Once you add a procedure category to a project, it becomes active.<br />
                  The project team can immediately start reviewing each procedure.
                </HeaderSubtitle>
              </HeaderContainer>
              <Divider />
            </>
          }
          <Formik
            enableReinitialize
            initialValues={{ categories: procedureCategories }}
            onSubmit={values =>
              setTimeout(() => {
                alert(JSON.stringify(values, null, 2));
              }, 500)
            }
            render={(formProps) => (
              <Form>

                {!displayConfirmation &&
                  formProps.values.categories.map((category, index) => <LoadProceduresItem key={index} category={category} fieldName={`categories.${index}`} gbus={context.projects.gbus} />)
                }
                {procedureCategories.length === 0 &&
                  <NoProceduresContainer>
                    <NoProceduresText>
                      Your function has not created any categories.
                    </NoProceduresText>
                  </NoProceduresContainer>
                }
                {displayConfirmation &&
                  <ConfirmationContainer>
                    <ConfirmationContainerText>
                      <b>You deselected a category that is already in use by the project.</b><br /><br />
                      Is this correct? All procedures in this category will immediately be removed from the project, and the project approvers will no longer see the procedures
                      in their workflow.
                    </ConfirmationContainerText>
                  </ConfirmationContainer>
                }
                <AddToProjectContainer>
                  {displayConfirmation &&
                    <Button
                      onClick={() => {
                        setdDiplayConfirmation(false);
                      }}
                      variant="outlined"
                      color="primary">
                      Go Back
                    </Button>
                  }
                  <div style={{ width: 10 }} />
                  <Button
                    disabled={!formProps.dirty}
                    onClick={() => {

                      if (shouldDisplayConfirmation(procedureCategories, formProps.values.categories) && !displayConfirmation) {
                        setdDiplayConfirmation(true);

                      } else {

                        handleClose();
                        context.importFunctionProcedureCategories({ functionId: context.reduxStore.selectedFunction.id, projectId: context.reduxStore.selectedProjectOrGbu.id, categories: formProps.values.categories });

                      }


                    }}
                    variant="outlined"
                    color="primary">
                    {displayConfirmation ? 'Confirm Changes' : 'Update Project'}
                  </Button>
                </AddToProjectContainer>
              </Form>
            )}
          />
        </PaperContainer>
      </Popover>
    </div>
  );

}

export default LoadProcedures;